import { toZuluTimeStr } from "./util/to-zulu-time-str";

export function datetimeTransformFn(datetimeArr: string[]) {
	return toZuluTimeStr(datetimeArr);
}
